import CardActivationScreen from 'features/cardManagement/screens/cardActivation/CardActivationScreen/CardActivationScreen';
import React from 'react';

export default function CardActivationPage() {
  return <CardActivationScreen />;
}
